"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadTransferRates = void 0;
const dayjs = require("dayjs");
const isBetween = require("dayjs/plugin/isBetween");
dayjs.extend(isBetween);
const loadTransferRates = async (supabase, rates, outbound_from, outbound_to, inbound_from, inbound_to, type, date, vehicle_id) => {
    let inbound_rate;
    let custom_rate;
    if (rates) {
        const results = rates.filter((rate) => {
            return (((rate.from_area === outbound_from && rate.to_area === outbound_to) ||
                (rate.from_area === outbound_to && rate.to_area === outbound_from)) &&
                // date between the rates start and end date inclusive
                dayjs(date).isBetween(rate.start_date, rate.end_date, null, "[]"));
        });
        const custom_results = rates.filter((rate) => {
            return ((rate.from_area === outbound_from &&
                rate.via_area === outbound_to &&
                rate.to_area === inbound_to) ||
                (rate.from_area === outbound_to &&
                    rate.via_area === outbound_from &&
                    rate.to_area === inbound_to &&
                    // date between the rates start and end date inclusive
                    dayjs(date).isBetween(rate.start_date, rate.end_date, null, "[]")));
        });
        return {
            outbound: results,
            inbound: results,
            custom: custom_results,
        };
    }
    else {
        const { data: outbound_rate } = await supabase.rpc("get_transfer_rates", {
            from_destination: outbound_from,
            to_destination: outbound_to,
            booking_date: dayjs(date).format("YYYY-MM-DD"),
        });
        if (type === "CUSTOM") {
            const { data: inbound } = await supabase.rpc("get_transfer_rates", {
                from_destination: inbound_from,
                to_destination: inbound_to,
                booking_date: dayjs(date).format("YYYY-MM-DD"),
            });
            inbound_rate = inbound;
            const { data: custom } = await supabase.rpc("get_custom_transfer_rates", {
                from_destination: outbound_from,
                via_destination: outbound_to,
                to_destination: inbound_to,
                booking_date: dayjs(date).format("YYYY-MM-DD"),
            });
            custom_rate = custom;
        }
        const transfer_rates = {
            outbound: vehicle_id
                ? outbound_rate.filter((x) => x.vehicle_id === vehicle_id)
                : outbound_rate,
            inbound: type === "CUSTOM"
                ? vehicle_id
                    ? inbound_rate.filter((x) => x.vehicle_id === vehicle_id)
                    : inbound_rate
                : vehicle_id
                    ? outbound_rate.filter((x) => x.vehicle_id === vehicle_id)
                    : outbound_rate,
            custom: vehicle_id
                ? custom_rate.filter((x) => x.vehicle_id === vehicle_id)
                : custom_rate,
        };
        return transfer_rates;
    }
};
exports.loadTransferRates = loadTransferRates;
